import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ConfigService } from '../../../../../services/config/config.service';
import { FeatureFlagsService } from '../../../../../services/feature-flag/feature-flag.service';
import { PaymentConfigService } from '../../../../../services/payment-config/payment-config.service';
import { ProductType } from '../../../../../interfaces/user';

export enum IdentitableButtonEnum {
  IdentibasePlusButton = 'IdentibasePlusButton',
  IdentialertButton = 'IdentialertButton'
}

@Component({
  selector: 'app-subscription-table-desktop',
  templateUrl: './subscription-table-desktop.component.html',
  styleUrls: ['./subscription-table-desktop.component.scss'],
})
export class SubscriptionTableDesktopComponent {
  @Input() identibasePlusButtonLabel: string;
  @Input() identialertButtonLabel: string;
  @Input() buyButtonVisible: boolean;
  @Input() buyButtonDisabled: boolean;
  @Output() identitableButtonClicked: EventEmitter<string> = new EventEmitter();

  @Input() basicPlusHighlighted: boolean;
  @Input() alertHighlighted: boolean;
  @Input() findHighlighted: boolean;

  public plan1Name = this.configService.getTextFromKey('1-plan-name');
  public plan1YearlyPrice = this.configService.getTextFromKey('1-plan-yearly-price');
  public plan2Name = this.configService.getTextFromKey('2-plan-name');
  public plan2YearlyPrice = this.configService.getTextFromKey('2-plan-yearly-price');
  public plan2MonthlyPrice = this.configService.getTextFromKey('2-plan-monthly-price');
  public isBrandPetlog: boolean;
  public useRebranded: boolean;

  constructor(
    private configService: ConfigService,
    private featureFlagService: FeatureFlagsService,
    private paymentConfigService: PaymentConfigService
  ) {
    this.isBrandPetlog = this.configService.isPetlogBrand();
    this.useRebranded = this.featureFlagService.isEnabled('useRebrandedLayout');

    this.plan1YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.BasicPlus) ?? this.plan1YearlyPrice;
    this.plan2YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.Premium) ?? this.plan2YearlyPrice;
    this.plan2MonthlyPrice = this.paymentConfigService.getMonthlyDisplayPrice(
      ProductType.Premium,
      this.plan2MonthlyPrice
    );
  }

  public regularIconSource =
    '/assets/images/identibase/identi-table-icons/checkmark.svg';
  public highlightedIconSource =
    '/assets/images/identibase/identi-table-icons/orange-checkmark.svg';

  public IdentitableButtonEnum = IdentitableButtonEnum;

  public onIdentitableButtonClicked(buttonClicked: string) {
    this.identitableButtonClicked.emit(buttonClicked);
  }
}
